export default {
  publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
}
